import { ReactNode, useEffect, useRef } from 'react';

import { company } from '~/company/Company';
import { CategorySkeleton } from '~/pages/Catalog/CatalogSkeleton';

interface InfinityScrollLoaderProps {
  onLoadMore(): void;
  className?: string;
  skeletons?: ReactNode;
  embedded?: boolean;
}

export const InfinityScrollLoader = ({
  onLoadMore,
  className = 'block-products',
  skeletons = <CategorySkeleton num={4} />,
  embedded,
}: InfinityScrollLoaderProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current || !onLoadMore) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const item = entries[0];

        if (item && item.intersectionRatio > 0) {
          onLoadMore();
        }
      },
      { rootMargin: `${window.innerHeight}px` },
    );

    ref.current && observer.observe(ref.current);

    return () => observer.disconnect();
  }, [onLoadMore]);

  if (embedded) {
    return (
      <>
        {skeletons}
        <div ref={ref} className={className} />
      </>
    );
  }
  return (
    <div ref={ref} data-company={company.name} className={className}>
      {skeletons}
    </div>
  );
};
